(function() {
    'use strict';

    angular
        .module('sodCommon')
        .factory('ButtonRegistry', myfactory);

    function myfactory (lodash) {
        var mybuttons = [];
        return {
            get: get,
            set: set,
            reset: reset,
            remove: remove,
            clearLoading: clearLoading,
            clearAllLoading: clearAllLoading,
            enableButtons: enableButtons,
            disableButtons: disableButtons,
            enableAllButtons: enableAllButtons,
            disableAllButtons: disableAllButtons,
            setLoading: setLoading,
            setAllLoading: setAllLoading
        };

        function get(scope_id) {
            // return mybuttons[button_id];
            return lodash.find(mybuttons, {angular_id: scope_id});
        }

        function set(button) {
            // mybuttons.push(button);
            mybuttons.push(button);
        }

        function remove(scope_id) {
            lodash.remove(mybuttons, { angular_id: scope_id});
        }

        function reset() {
            mybuttons = [];
        }

        function setLoading(name) {
            var buttons = lodash.filter(mybuttons, {name: name});
            angular.forEach(buttons, function (button) {
                button.loading = true;
            });
        }

        function clearLoading(name) {
            //mybuttons[button_id].loading = false;
            var buttons = lodash.filter(mybuttons, {name: name});
            angular.forEach(buttons, function (button) {
                button.loading = false;
            });
        }

        function setAttribute(name, attribute, value) {
            var buttons = lodash.filter(mybuttons, {name: name});
            angular.forEach(buttons, function (button) {
                lodash.set(button, attribute, value);
            });
        }

        function clearAllLoading() {
            angular.forEach(mybuttons, function(button) {
                button.loading = false;
            });
        }

        function setAllLoading() {
            angular.forEach(mybuttons, function(button) {
                button.loading = true;
            });
        }

        function enableButtons(buttonNames) {
            angular.forEach(buttonNames, function(name) {
                setAttribute(name, 'attr.disabled', false);
            });
        }

        function disableButtons(buttonNames) {
            angular.forEach(buttonNames, function(name) {
                //lodash.set(mybuttons, [name, 'attr.disabled'].join('.'), true);
                setAttribute(name, 'attr.disabled', true);
            });
        }

        function enableAllButtons() {
            angular.forEach(mybuttons, function(button) {
                lodash.set(button, 'attr.disabled', false);
            });
        }

        function disableAllButtons() {
            angular.forEach(mybuttons, function(button) {
                lodash.set(button, 'attr.disabled', true);
            });
        }
    }
})();